(function() {
    'use strict';

    angular
        .module('szallodak-dashboard', []);
})();
